import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { getDashboardLookML, importDashboardFromLookML } from '../../../lib/api/looker/api';
import type { GetDashboardLookMLRequest, ImportDashboardFromLookMLRequest } from '../../../lib/api/looker/dto';
import { hashDashboardSections } from '../../useLooker';

export const useDashboardLookML = (params: GetDashboardLookMLRequest) => {
  const query = useQuery({
    queryKey: ['getDashboardLookML', params],
    queryFn: async () => {
      const objectsHash = await hashDashboardSections(params.objectList ?? []);
      const lookml = await getDashboardLookML(params);
      return { objectsHash, lookml };
    },
    enabled: Object.values(params).every(Boolean),
    staleTime: Infinity,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
};

export const useImportDashboardFromLookML = (params: ImportDashboardFromLookMLRequest) => {
  const [reloadKey, setReloadKey] = useState(1);

  const query = useQuery({
    queryKey: ['importDashboardFromLookML', params.objectsHash],
    queryFn: async () => {
      const response = await importDashboardFromLookML(params);
      setReloadKey((prev) => prev + 1);
      return response;
    },
    enabled: !!params.lookml && !!params.objectsHash,
    staleTime: Infinity,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    reloadKey,
  };
};
